import React, {PureComponent, Fragment} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import Button from '@spothero/ui/button';
import WithConfig from 'config/WithConfig';
import {
    toggleFiltersView,
    toggleMobileListView
} from 'search/search-actions';
import {
    resetSelectedSpot,
    updateSelected
} from 'spot/spot-actions';
import Icon from 'common/icon/Icon';
import Navigation from './Navigation';

class HeaderMobile extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        isProduction: PropTypes.bool,
        user: PropTypes.object,
        searchType: PropTypes.string,
        pageType: PropTypes.string,
        isSearchPage: PropTypes.bool,
        isMobileListViewActive: PropTypes.bool.isRequired,
        selectedSpot: PropTypes.object,
        isFiltered: PropTypes.bool,
        onFiltersToggle: PropTypes.func,
        showMobileListView: PropTypes.func,
        setSelectedSpot: PropTypes.func,
        clearSelectedSpot: PropTypes.func.isRequired
    };

    _onListViewClick = () => {
        this.props.showMobileListView(true);
    }

    _onMapViewClick = () => {
        this.props.showMobileListView(false);
    }

    _onSpotDetailsHidden = () => {
        this.props.setSelectedSpot();
    }

    render() {
        const {
            className,
            isProduction,
            user,
            isMobileListViewActive,
            selectedSpot,
            isFiltered,
            searchType,
            pageType,
            isSearchPage,
            onFiltersToggle,
            clearSelectedSpot
        } = this.props;
        const alternateControl = (selectedSpot)
            ? 'back'
            : (isMobileListViewActive)
                ? 'map'
                : 'list';
        const classes = classNames(
            'Header',
            {'Header-brand-hidden': isSearchPage && alternateControl === 'back'},
            className
        );
        const filtersToggleClasses = classNames(
            'Header-alternate-control',
            'Header-filters-toggle',
            {'Header-alternate-control-active': isFiltered}
        );

        return (
            <header
                className={classes}
                role="banner"
            >
                <div className="Header-bar">
                    {isSearchPage &&
                        <Fragment>
                            {(searchType !== 'venue') &&
                                <Button
                                    className={filtersToggleClasses}
                                    onClick={onFiltersToggle}
                                >
                                    <Icon name="filter" />
                                </Button>
                            }
                            {(searchType !== 'venue' && alternateControl === 'list') &&
                                <Button
                                    className="Header-alternate-control Header-map-toggle"
                                    onClick={this._onListViewClick}
                                >
                                    List
                                </Button>
                            }
                            {(searchType !== 'venue' && alternateControl === 'map') &&
                                <Button
                                    className="Header-alternate-control Header-map-toggle"
                                    onClick={this._onMapViewClick}
                                >
                                    Map
                                </Button>
                            }
                        </Fragment>
                    }
                    {(isSearchPage || pageType === 'checkout') &&
                        <Fragment>
                            {(searchType !== 'venue' && alternateControl === 'back') &&
                                <Button
                                    className="Header-alternate-control HeaderMobile-back"
                                    onClick={(pageType === 'checkout')
                                        ? null
                                        : this._onSpotDetailsHidden
                                    }
                                >
                                    Back
                                </Button>
                            }
                        </Fragment>
                    }
                </div>
                <div className="Header-bar-background" />
                <Navigation
                    isProduction={isProduction}
                    user={user}
                    onItemSelected={clearSelectedSpot}
                />
            </header>
        );
    }
}

const mapStateToProps = state => {
    const {
        filters: {
            numActive
        },
        search: {
            data: {
                searchType,
                isMobileListViewActive
            }
        },
        searchRequest: {
            pageType,
            isSearchPage
        },
        spot: {
            selected
        },
        user: {
            data: userData
        }
    } = state;

    return {
        user: userData,
        searchType,
        isMobileListViewActive,
        selectedSpot: selected,
        isFiltered: (numActive > 0),
        pageType,
        isSearchPage
    };
};

const mapDispatchToProps = {
    onFiltersToggle: toggleFiltersView,
    showMobileListView: toggleMobileListView,
    setSelectedSpot: updateSelected,
    clearSelectedSpot: resetSelectedSpot
};

const enhance = compose(
    WithConfig,
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(HeaderMobile);
